import { jsxs, jsx } from "react/jsx-runtime";
import { forwardRef, useMemo } from "react";
import { set, minutesToHours, hoursToMinutes, getHours, getMinutes, format } from "date-fns";
import { CLINIC_STARTING_HOUR, CLINIC_ENDING_HOUR, TIME_FORMAT, SLOT_TIME, EXTENDED_SLOT_HEIGHT, SLOT_HEIGHT } from "../../appointment-schedule.constants.js";
import { useTimeIndicator } from "../../providers/time-indicator-provider.js";
import { generateInterval } from "./time-column.helpers.js";
import { ColumnWrapper, TimeIndicatorWrapper, TimeIndicatorInfo, IntervalWrapper, TimeDetails } from "./time-column.styles.js";
import "date-fns/getHours";
import "date-fns/isThisWeek";
import "date-fns/isToday";
import "date-fns/isValid";
import "@mui/material";
import "@mui/material/styles";
const TimeColumn = forwardRef(
  ({ startHour, endHour, showExtendedView = false, offset: containerOffset = 0, lineWidth }, timeColumnEl) => {
    const { shouldShowIndicator, time } = useTimeIndicator();
    const start = useMemo(() => startHour ?? set(/* @__PURE__ */ new Date(), { hours: CLINIC_STARTING_HOUR, minutes: 0 }), [startHour]);
    const end = useMemo(() => endHour ?? set(/* @__PURE__ */ new Date(), { hours: CLINIC_ENDING_HOUR, minutes: 0 }), [endHour]);
    const intervals = useMemo(
      () => generateInterval({
        start,
        end,
        showExtendedView
      }),
      [start, end, showExtendedView]
    );
    const TIME_COLUMN_SLOT_HEIGHT = showExtendedView ? EXTENDED_SLOT_HEIGHT : SLOT_HEIGHT;
    const intervalHeight = 60 / SLOT_TIME * TIME_COLUMN_SLOT_HEIGHT;
    const offset = useMemo(() => {
      const containerOffsetInMinutes = containerOffset / TIME_COLUMN_SLOT_HEIGHT * SLOT_TIME;
      const numberOfHours = CLINIC_ENDING_HOUR - CLINIC_STARTING_HOUR + minutesToHours(containerOffsetInMinutes);
      const minutesToOffset = hoursToMinutes(getHours(time)) + getMinutes(time) - hoursToMinutes(CLINIC_STARTING_HOUR) + containerOffsetInMinutes;
      return minutesToOffset / (numberOfHours * 60) * 100;
    }, [time, containerOffset]);
    const displayTime = useMemo(() => format(time, TIME_FORMAT), [time]);
    return /* @__PURE__ */ jsxs(ColumnWrapper, { ref: timeColumnEl, offset: containerOffset, elevation: 1, children: [
      shouldShowIndicator && !showExtendedView && /* @__PURE__ */ jsx(TimeIndicatorWrapper, { top: offset, children: /* @__PURE__ */ jsx(TimeIndicatorInfo, { variant: "Lato Caption Bold", children: displayTime }) }),
      intervals.map((item) => /* @__PURE__ */ jsx(IntervalWrapper, { height: intervalHeight, lineWidth, children: /* @__PURE__ */ jsx(TimeDetails, { variant: "Lato Caption", children: item }) }, `${item}`))
    ] });
  }
);
TimeColumn.displayName = "TimeColumn";
export {
  TimeColumn
};
